import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalDialog } from './ModalDialog';

import styles from './ClaimValidationModal.module.css';

const ClaimValidationModal = ({
  onClose = () => { },
  visible = false,
}) => {
  const { t } = useTranslation('myAccount');

  return (
    <ModalDialog
      onClose={onClose}
      show={visible}
    >
      <div className={styles.mainContainer}>
        <h2>{t('reimbursementSection.claimValidationModal.title')}</h2>

        <p>{t('reimbursementSection.claimValidationModal.description')}</p>
      </div>
    </ModalDialog>
  );
};

export { ClaimValidationModal };
